"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toRSEDocumentListSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var fields_1 = require("../fields");
var slice_1 = require("./slice");
var toRSEDocumentListSlice = function (data, logger) {
    var title = logger.required(fields_1.toText(data.primary.title));
    var subTitle = fields_1.toText(data.primary.subTitle);
    var nbYear = logger.required(fields_1.toNumber(data.primary.nbYear));
    if (title && nbYear > 0) {
        return utils_1.compact(__assign(__assign({}, slice_1.toSlice(data, types_1.SliceType.RSEDocumentList)), { title: title,
            subTitle: subTitle,
            nbYear: nbYear }));
    }
};
exports.toRSEDocumentListSlice = toRSEDocumentListSlice;
//# sourceMappingURL=rse-document-list-slice.js.map